{
  "en": {
    "close": "Close",
    "dataIterator": {
      "pageText": "{0}-{1} of {2}",
      "noResultsText": "No matching records found",
      "loadingText": "Loading items..."
    },
    "pagination": {
      "ariaLabel": {
        "next": "Next",
        "previous": "Previous",
        "page": "Page",
        "currentPage": "Current page",
        "wrapper": "Wrapper"
      }
    },
    "dataTable": {
      "itemsPerPageText": "Rows per page:",
      "ariaLabel": {
        "sortDescending": ": Sorted descending. Activate to remove sorting.",
        "sortAscending": ": Sorted ascending. Activate to sort descending.",
        "activateAscending": "Activate ascending",
        "activateDescnding": ": Activate descending",
        "sortNone": ": Not sorted. Activate to sort ascending."
      },
      "sortBy": "Sort by"
    },
    "dataFooter": {
      "pageText": "{0}-{1} of {2}",
      "itemsPerPageText": "Items per page:",
      "itemsPerPageAll": "All",
      "nextPage": "Next page",
      "prevPage": "Previous page",
      "firstPage": "First page",
      "lastPage": "Last page"
    },
    "datePicker": {
      "itemsSelected": "{0} selected"
    },
    "noDataText": "No data available",
    "carousel": {
      "prev": "Previous visual",
      "next": "Next visual"
    },
    "calendar": {
      "moreEvents": "{0} more"
    },
    "badge": "badge"
  },
  "fr": {
    "close": "Fermer",
    "dataIterator": {
      "pageText": "{0}-{1} sur {2} au total",
      "noResultsText": "Aucun résultat",
      "loadingText": "Chargement..."
    },
    "pagination": {
      "ariaLabel": {
        "next": "Suivant",
        "previous": "Précédent",
        "page": "Page",
        "currentPage": "Page courrante",
        "wrapper": "Wrapper"
      }
    },
    "dataTable": {
      "itemsPerPageText": "Éléments par page :",
      "ariaLabel": {
        "sortDescending": ": Sorted descending. Activate to remove sorting.",
        "sortAscending": ": Sorted ascending. Activate to sort descending.",
        "activateAscending": "Activate ascending",
        "activateDescnding": ": Activate descending",
        "sortNone": ": Not sorted. Activate to sort ascending."
      },
      "sortBy": "Sort by"
    },
    "dataFooter": {
      "pageText": "{0}-{1} sur {2} au total",
      "itemsPerPageText": "Éléments par page:",
      "itemsPerPageAll": "Tout",
      "nextPage": "Page suivante",
      "prevPage": "Page précédente",
      "firstPage": "Première page",
      "lastPage": "Dernière page"
    },
    "datePicker": {
      "itemsSelected": "{0} selected"
    },
    "noDataText": "Aucun élément",
    "carousel": {
      "prev": "Précédent",
      "next": "Suivant"
    },
    "calendar": {
      "moreEvents": "{0} de plus"
    },
    "badge": "badge"
  },
  "nl": {
    "close": "Sluit",
    "dataIterator": {
      "pageText": "{0}-{1} van {2} totaal.",
      "noResultsText": "Geen resultaten.",
      "loadingText": "Laden..."
    },
    "pagination": {
      "ariaLabel": {
        "next": "Volgende",
        "previous": "Vorige",
        "page": "Pagina",
        "currentPage": "Huidige pagina",
        "wrapper": "Wrapper"
      }
    },
    "dataTable": {
      "itemsPerPageText": "Artikelen per pagina :",
      "ariaLabel": {
        "sortDescending": "Aflopend gesorteerd. Activeer om de sortering te verwijderen.",
        "sortAscending": "oplopend gesorteerd. Activeer om aflopend te sorteren.",
        "activateAscending": "Activeer oplopend",
        "activateDescnding": ": Activeer aflopende",
        "sortNone": "Niet gesorteerd. Activeer om oplopend te sorteren."
      },
      "sortBy": "Sorteren op"
    },
    "dataFooter": {
      "pageText": "{0}-{1} van {2} totaal.",
      "itemsPerPageText": "Items per pagina:",
      "itemsPerPageAll": "Alle",
      "nextPage": "Volgende pagina",
      "prevPage": "Vorige pagina",
      "firstPage": "Eerste pagina",
      "lastPage": "Laatste pagina"
    },
    "datePicker": {
      "itemsSelected": "{0} geselecteerd"
    },
    "noDataText": "Geen items",
    "carousel": {
      "prev": "Vorige",
      "next": "Volgende"
    },
    "calendar": {
      "moreEvents": "{meer"
    },
    "badge": "badge"
  }
}
